"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var _1 = require(".");

var utils_1 = require("./utils");

var defaultProps = {
  stroke: '#3D99FF'
};

exports.CircularProgress = function (props) {
  var _a = _1.useCircularInputContext(),
      value = _a.value,
      radius = _a.radius,
      center = _a.center;

  var innerCircumference = utils_1.DEG_360_IN_RAD * radius;
  return react_1.default.createElement(_1.CircularTrack, __assign({}, props, {
    strokeDasharray: innerCircumference,
    strokeDashoffset: innerCircumference * (1 - value),
    transform: "rotate(-90 " + center.x + " " + center.y + ")"
  }));
};

exports.CircularProgress.defaultProps = defaultProps;